import { createApiCaller, apiToActionRes } from './api/util'

const callApi = createApiCaller('htj2')
const callApiLg = createApiCaller('htj2Lg')

type MaintenancePlan = {
	maintenancePlan: any
}

export const _getMaintenancePlan = async (companyUUID: string) => {
	// TODO: Add proper response type once it's defined
	return apiToActionRes<MaintenancePlan>(
		callApi(`/get-maintenance-plan`, {
			method: 'POST',
			body: {
				companyUUID,
			},
		}),
	)
}

export type AuthzStartAuthFlowResponse =
	| {
			authUUID: string
			authKeyAlreadyExists: false
	  }
	| {
			authUUID: null
			authKeyAlreadyExists: true
	  }
export const _systemAuthzStartAuthFlow = async (managerUUID: string) => {
	return apiToActionRes<AuthzStartAuthFlowResponse>(
		callApi('/system-authorization-flow/start-authz-flow', {
			method: 'POST',
			body: {
				managerUUID,
			},
		}),
	)
}

export type AuthzFinalizeResponse = {
	authKeyWorks: boolean
	authKeyFor: string
	authKeyType: 'manager' | 'user'
}
export const _systemAuthzFinalizeAuthzFlow = async (managerUUID: string) => {
	return apiToActionRes<AuthzFinalizeResponse>(
		callApi('/system-authorization-flow/finalize-authz-flow', {
			method: 'POST',
			body: {
				managerUUID,
			},
		}),
	)
}

export type AuthzCheckResponse = {
	authKeyWorks: boolean
	authorizationKeyType: 'manager' | 'user' | null
}
export const _systemAuthzCheckAuthz = async ({
	managerUUID,
	companyUUID,
}: {
	managerUUID: string
	companyUUID: string | undefined
}) => {
	return apiToActionRes<AuthzCheckResponse>(
		callApi('/system-authorization-flow/check-authz', {
			method: 'POST',
			body: {
				managerUUID,
				companyUUID,
			},
		}),
	)
}

export const _syncHTJ2Schema = async () => {
	return apiToActionRes(
		callApiLg(`/sync-htj2-schema`, {
			method: 'POST',
		}),
	)
}

export const _exportAdminInfoToHTJ2 = async (companyUUID: string) => {
	return apiToActionRes(
		callApi(`/export-admin-info-to-htj2`, {
			method: 'POST',
			body: {
				companyUUID,
			},
		}),
	)
}
